import { SkeletonProps } from 'antd'
import { isNil } from 'lodash-es'
import isUndefined from 'lodash-es/isUndefined'
import React, { FunctionComponent, ReactNode } from 'react'
import Blur from '@/components/common/blur'
import { Duration } from '@/components/common/duration-select'
import KolDetailStatistic from '@/components/kol/common/kol-detail-statistic'
import { KolDetailDuration } from '@/hooks/use-authorization/routes'
import { useIntl } from '@/i18n/hooks/use-intl'
import { KpiSchema } from '@/types/schema/kpi-schema'

interface SponsoredCoverageStatisticProps {
  isKolInfoLocked: boolean
  showMockData?: boolean
  statisticLoading: SkeletonProps | boolean
  kpi?: KpiSchema
  duration: KolDetailDuration
}

const SponsoredCoverageStatistic: FunctionComponent<
  SponsoredCoverageStatisticProps
> = ({ isKolInfoLocked, showMockData, statisticLoading, kpi, duration }) => {
  const { formatMessage, formatNumber } = useIntl()

  const sponsorPostRatio = ((): number | null => {
    if (isUndefined(kpi)) {
      return null
    }

    return duration === Duration.ThreeMonths
      ? kpi.sponsorPostRatio3m
      : kpi.sponsorPostRatio6m
  })()

  return (
    <KolDetailStatistic
      loading={statisticLoading}
      title={formatMessage({
        id: 'kol:sponsored_collaboration_data_block_sponsored_coverage_title',
      })}
      value={((): ReactNode => {
        if (isKolInfoLocked) {
          return (
            <Blur activate={!showMockData}>
              {formatNumber(0.3, { isPercentageDisplay: true })}
            </Blur>
          )
        }

        if (isNil(sponsorPostRatio) || sponsorPostRatio === 0) {
          return 'noData'
        }

        return formatNumber(sponsorPostRatio, {
          isPercentageDisplay: true,
        })
      })()}
    />
  )
}

export default SponsoredCoverageStatistic
